export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.config.errorHandler = (error) => {
        if (error.message.includes('ccall')) {
            clearError({ redirect: `/${nuxtApp.$i18n.locale.value}` });
        }
    };
});
